
export function transformVersionToCountryFlag(version) {
  const base = `${d2gPmThemeKonsolenkostPath}/images/flags`;

  switch (version) {
    case "ARA Version":
    case "ARA Import":
    case "ARAB Version":
    case "ARAB Import":
      return `${base}/arab.svg`;
    case "ARE Version":
    case "ARE Import":
    case "UAE Version":
    case "UAE Import":
      return `${base}/ae.svg`;
    case "AT Import":
    case "AT Version":
      return `${base}/at.svg`;
    case "CH Versoin":
    case "CH Import":
    case "CHE Version":
    case "CHE Import":
      return `${base}/ch.svg`;
    case "DE Version":
      return `${base}/de.svg`;
    case "CHN Version":
    case "CHN Import":
    case "CN Version":
    case "CN Import":
      return `${base}/cn.svg`;
    case "HK Import":
    case "HK Version":
    case "HKG Version":
    case "HKG Import":
      return `${base}/hk.svg`;
    case "DK Version":
    case "DK Import":
    case "DNK Version":
    case "DNK Import":
      return `${base}/dk.svg`;
    case "CA Version":
    case "CA Import":
    case "CAN Version":
    case "CAN Import":
      return `${base}/ca.svg`;
    case "UK Import":
    case "UK Version":
    case "GB Version":
    case "GB Import":
      return `${base}/gb.svg`;
    case "US Import":
    case "US Version":
      return `${base}/us.svg`;
    case "BE Version":
    case "BE Import":
    case "BEL Version":
    case "BEL Import":
      return `${base}/be.svg`;
    case "BNL Import":
    case "BNL Version":
      return `${base}/bnl.svg`;
    case "CZ Version":
    case "CZ Import":
    case "CZE Version":
    case "CZE Import":
      return `${base}/cz.svg`;
    case "GRC Version":
    case "GRC Import":
      return `${base}/gr.svg`;
    case "HUN Version":
    case "HUN Import":
      return `${base}/hu.svg`;
    case "SK Version":
    case "SK Import":
    case "SVK Version":
    case "SVK Import":
      return `${base}/sk.svg`;
    case "EU Version":
      return `${base}/eu.svg`;
    case "FIN Version":
    case "FIN Import":
      return `${base}/fi.svg`;
    case "FR Version":
    case "FR Import":
    case "FRA Version":
    case "FRA Import":
      return `${base}/fr.svg`;
    case "IT Version":
    case "IT Import":
    case "ITA Version":
    case "ITA Import":
      return `${base}/it.svg`;
    case "JAP Import":
    case "JAP Version":
      return `${base}/jp.svg`;
    case "NL Version":
    case "NL Import":
    case "NLD Import":
    case "NLD Version":
    case "HOL Version":
    case "HOL Import":
      return `${base}/nl.svg`;
    case "NOR Version":
    case "NOR Import":
      return `${base}/no.svg`;
    case "POL Version":
    case "POL Import":
      return `${base}/pl.svg`;
    case "BRA Version":
    case "BRA Import":
      return `${base}/br.svg`;
    case "PORT Version":
    case "PORT Import":
    case "PRT Version":
    case "PRT Import":
      return `${base}/pt.svg`;
    case "RU Version":
    case "RU Import":
    case "RUS Import":
    case "RUS Version":
      return `${base}/ru.svg`;
    case "ESP Version":
    case "ESP Import":
      return `${base}/se.svg`;
    case "SWE Version":
    case "SWE Import":
      return `${base}/se.svg`;
    case "AU Version":
    case "AU Import":
    case "AUS Import":
    case "AUS Version":
      return `${base}/au.svg`;
    case "KOR Version":
    case "KOR Import":
      return `${base}/kr.svg`;
    case "SAU Version":
    case "SAU Import":
      return `${base}/sa.svg`;
    case "SGP Version":
    case "SGP Import":
      return `${base}/sg.svg`;
    case "TR Version":
    case "TR Import":
    case "TUR Version":
    case "TUR Import":
      return `${base}/tr.svg`;
    case 'PAL':
    case 'PAL-A':
    case 'PAL-B':
    case 'PAL-ASIA':
    case 'PAL-I':
      return `${base}/pal.svg`;
    case 'NTSC':
    case 'NTSC-J':
      return `${base}/ntsc.svg`;
    default:
      return `${base}/de.svg`;
  }
}